<template>
<div class="powered-by footer">
 <div class="PoweredBy">
  <span>Powered By</span>
<a href="https://www.thawani.om"  target="_blank" class="LogoLink" >
<img class="w-25   block" src="@/assets/images/logo.svg"   alt=""/>
</a>
  </div>

     <div>

      <div class="logos">
        <a href="https://www.facebook.com/ThawaniPay/" target="_blank">
          <img class="w-25   block" src="@/assets/images/facebook.svg"  alt=""/>
        </a>
        <a href="https://www.instagram.com/thawani_pay/?hl=en" target="_blank">
          <img class="w-25   block" src="@/assets/images/instagram.svg" alt=""  />
        </a>
        <a href="https://www.linkedin.com/company/11481432/admin/" target="_blank">
          <img class="w-25   block" src="@/assets/images/linkedin.svg" alt="" />
        </a>
        <a href="https://twitter.com/Thawani_Pay?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank">
          <img class="w-25   block" src="@/assets/images/twitter.svg" alt="" />
        </a>
        <a href="https://www.youtube.com/channel/UCC7mkPwO_3Dua9KamWh2QNQ" target="_blank">
          <img class="w-25   block" src="@/assets/images/youtube.svg" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PoweredBy'
}
</script>

<style scoped>
.powered-by{
  padding:20px 0;
}
.footer {
  position: absolute;
  bottom: 0;
  background: #fff;
  width: 100vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  place-items: center;
  gap: 0.9rem;
  left: 0;
  right: 0;
  padding: 15px;
}
.logos {
  display: flex;
  place-items: center;
  justify-content: center;
    gap: 0.5rem;
}

.PoweredBy{
  display: flex;
  place-items: center;
  justify-content: center;
  color: #B8B8C0;
  gap: 0.7rem;
}
.LogoLink{
  width: 36%;
}
.Downloadlogos {
  display: flex;
  place-items: center;
  justify-content: center;
  gap: 0.3rem;
  margin-bottom: 4px;
}
.logos a img {
  width: 100%;
  margin: auto;
}
.logos a{
 width: 9%;
}
.Downloadlogos a img {
  width: 100%;
  margin: auto;
}
.Downloadlogos a {
  width: 14%;
}
.vist-us {
  color: #444;
  font-size: 18px;
  text-align: center;
  margin-bottom: 4px;
}
a.thawaniUrl {
  color: #6bc048;
  font-size: 18px;
  text-align: center;
  margin-bottom: 4px;
  letter-spacing: 0.8px;
  font-weight: 300;
}

@media (max-height: 600px) {
 .logos a img {
    width: 20px;
  }
  .PoweredBy span{
 font-size: 12px;
  }
  .LogoLink{
  width: 25%;
}
.footer{
  position: relative;
  bottom: 0;
  background: transparent;
  width: 100vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  place-items: center;
  gap: 0.5rem;
  left: 0;
  right: 0;
  border-top: 1px solid #fbfbfb;
}
}
@media only screen and (max-width: 600px){
  .logos a img {
    width: 20px;
  }
  .logos {
    gap: 5px;
  }
  .Downloadlogos a img {
    width: 14px;
  }
  .vist-us {
    font-size: 12px;
  }
  a.thawaniUrl {
    color: #6bc048;
    font-size: 12px;
    letter-spacing: 1px;
  }
  .logos a{
    width: 14%;
  }
.PoweredBy{
  display: flex;
  place-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #B8B8C0;
  font-size:12px;
}
.LogoLink{
  width: 27%;
}
}
</style>
